// Varmuuskopion tila ylläpitäjälle: tilarivi Ylläpito-osiossa ja varoitus Passin yläreunassa,
// kun kopiointi on myöhässä tai epäonnistunut. Tavalliselle pelaajalle ei näytetä mitään.

import { useEffect, useState } from "preact/hooks";

import { backupLine, needsAttention } from "../lib/backupStatus.js";

/** Hakee tilan, kun ylläpito on päällä. Palauttaa { status, error, reload }. */
function useBackupStatus(app) {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(false);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!app.admin) return undefined;
    let alive = true;
    app.api.adminBackup().then(
      (data) => {
        if (!alive) return;
        setStatus(data);
        setError(false);
      },
      () => alive && setError(true),
    );
    return () => {
      alive = false;
    };
  }, [app.admin, tick]);
  return { status, error, reload: () => setTick((t) => t + 1) };
}

/** Tilarivi Ylläpito-osioon. */
export function BackupStatusCard({ app }) {
  const { status, error, reload } = useBackupStatus(app);
  const line = status ? backupLine(status) : null;
  return (
    <section class="backup-card" aria-label="Varmuuskopiointi">
      <h2>Varmuuskopiointi</h2>
      {error && <p class="rec-note warn" role="alert">Tilaa ei saatu palvelimelta.</p>}
      {!error && !line && <p class="s">Haetaan…</p>}
      {line && (
        <div class={`backup-line ${line.tone}`} role={line.tone === "warn" ? "alert" : "status"}>
          <b>{line.title}</b>
          {line.detail && <span>{line.detail}</span>}
        </div>
      )}
      <div class="sheet-actions">
        <button class="btn btn-quiet" onClick={reload}>Päivitä tila</button>
      </div>
    </section>
  );
}

/** Passin yläreunan varoitus: näkyy vain ylläpitäjälle ja vain, kun jokin on pielessä. */
export function BackupWarning({ app }) {
  const { status } = useBackupStatus(app);
  if (!app.admin || !needsAttention(status)) return null;
  const line = backupLine(status);
  return (
    <p class="rec-note warn backup-warning" role="alert">
      <b>{line.title}.</b> {line.detail}
    </p>
  );
}
